import { SpeakerRequestStatusEnum } from 'graphql/types';
import { TStatusMap } from './AppliedNotification.types';

export const statusMap: TStatusMap = {
  [SpeakerRequestStatusEnum.Pending]: {
    name: 'На рассмотрении',
    color: 'primary',
    iconName: 'spinner',
    iconColor: '#426FFF',
  },
  [SpeakerRequestStatusEnum.Inprogress]: {
    name: 'На рассмотрении',
    color: 'primary',
    iconName: 'spinner',
    iconColor: '#426FFF',
  },
  [SpeakerRequestStatusEnum.Approved]: {
    name: 'Одобрена',
    color: 'primary',
    iconName: 'success',
  },
  [SpeakerRequestStatusEnum.Declined]: {
    name: 'Отклонена',
    color: 'decline',
    iconName: 'warning',
  },
};
